import { truncate2Digits } from './utils';
import { IVideoSizes } from './video-utils';

export const RATIO = {
  VERTICAL: 9 / 16,
  RECTANGLE: 4 / 3,
  LANDSCAPE: 16 / 9
};

export function getClosestRatio(
  videoRealRatio: number,
  ratios: number[] = [RATIO.LANDSCAPE, RATIO.RECTANGLE, RATIO.VERTICAL],
  defaultRatio: number = RATIO.LANDSCAPE
): number {
  if (videoRealRatio === 0) {
    return defaultRatio;
  }
  return ratios.reduce((closest, ratio) =>
    Math.abs(videoRealRatio - ratio) < Math.abs(videoRealRatio - closest)
      ? ratio
      : closest
  );
}

export function getRatioFromSizes(
  creativeRatio: number | undefined,
  videoSizes: IVideoSizes
): number {
  if (typeof creativeRatio === 'number') {
    return truncate2Digits(creativeRatio);
  }

  if (videoSizes.video_width && videoSizes.video_height) {
    return truncate2Digits(videoSizes.video_width / videoSizes.video_height);
  }

  if (videoSizes.vast_video_width && videoSizes.vast_video_height) {
    return truncate2Digits(
      videoSizes.vast_video_width / videoSizes.vast_video_height
    );
  }

  return 0;
}
